import { Component, OnInit, Input, ChangeDetectorRef, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray, UntypedFormControl, FormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ECalendarValue, IDatePickerConfig, } from 'ng2-date-picker';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTimepickerModule } from 'mat-timepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout/flex';

class CustomErrorStateMatcher implements ErrorStateMatcher {
        isErrorState(control: UntypedFormControl | null) {
          return control.invalid;
        }
      }
@Component({
    selector: 'app-timeRange-view',
    templateUrl: './timeRange-view.component.html',
    styleUrls: ['./timeRange-view.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatFormFieldModule,
        MatTimepickerModule,
        FormsModule,
        MatIconModule,
        NgIf,
    ],
})
export class TimeRangeViewComponent implements OnInit {
    constructor(private ref: ChangeDetectorRef, private fb: UntypedFormBuilder) {}

    //service item data
    @Input() product;

    @Input() availableFrom: Date;

    @Input() availableTo: Date;

    @Input() selectedStart: Date;
    @Input() selectedEnd: Date;


    @Input()time = this.fb.group({
        start: [null],
        end: [null]
    });

        onSelectFrom(data) {
            let date = new Date(data);
            this.selectedStart = date;
            this.time.get('start').setValue(date);
          }

          onSelectTo(data) {
            let date = new Date(data);
            this.selectedEnd = date;
            this.time.get('end').setValue(date);
          }

          /* onSelectFrom(data) {
            let date = new Date(data);
            this.selectedStart = date;
            this.time.get('start').setValue(date);
          }

          onSelectTo(data) {
            let date = new Date(data);
            this.selectedEnd = date;
            this.time.get('end').setValue(date);
          } */

          customErrorStateMatcher = new CustomErrorStateMatcher();

    initTime = () => {

        try {

                /* this.selectedStart = new Date(this.availableFrom);
                this.selectedEnd = new Date(this.availableTo); */

        } catch (error) {
            console.log(
                'Error initing Time Picker: ' + error?.toString()
            );
        }
    };



    ngOnInit(): void {


        this.initTime();
    }


}
